import React, { Fragment } from 'react';
import loadable from '@loadable/component';
import { fetchProperty, clearProperty } from 'store/property/propertyActions';
import { clearPointsTiers } from 'store/pointsConversion/pointsConversionActions';
import FeaturedPropertyRedirector from './FeaturedPropertyRedirector';
import { useTrackPropertyPageView } from './hooks/useTrackPropertyPageView';

export const AsyncPropertyLayout = loadable(() => import(/* webpackPrefetch: true */ './PropertyLayout'));

const Property = (props) => {
  useTrackPropertyPageView();
  return (
    <Fragment>
      <FeaturedPropertyRedirector />
      <AsyncPropertyLayout {...props} />
    </Fragment>
  );
};

Property.onEnterPage = ({ store }) => {
  store.dispatch(fetchProperty());
};

Property.onExitPage = ({ store }) => {
  store.dispatch(clearProperty());
  store.dispatch(clearPointsTiers());
};

Property.activeSplits = ['blue_banner_message', 'property_page_filters', 'property_page_availability'];

export default Property;
